import { Http } from '../../shared';
import { settings } from '../../settings';

export class ShoppingCartService {
    constructor() {
        this.http = new Http();
        this.service_url = settings.gateway_api.base_url;
    }
    async create(data) {
        var response = await this.http.post(this.service_url + '/shopping-carts', data);
        var result = {
            data: response.data
        };
        return result;
    }
    async addLeg(data) {
        var response = await this.http.post(this.service_url + '/shopping-carts/legs/add', data);
        var result = {
            data: response.data
        };
        return result;
    }
    async calculate(data) {
        var response = await this.http.post(this.service_url + '/shopping-carts/calculate', data);
        return response.data;
    }
    async updateProduct(data){
        var response = await this.http.post(this.service_url + '/shopping-carts/products/update', data);
        return response.data; 
    }
    async updateProducts(data){
        var response = await this.http.post(this.service_url + '/shopping-carts/products', data);
        return response.data; 
    }
}
